// 校园吃瓜网 - 首页静态内容数据
// 仅供页面静态展示使用；用户投稿通过 Readdy Form 收集，经小编审核后上墙。

export interface Category {
  key: string;
  label: string;
  emoji: string;
  desc: string;
  count: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: "dorm",
    label: "宿舍名场面",
    emoji: "🛏",
    desc: "被子山、深夜茶话会和说不完的夜聊",
    count: "1.2k+",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20cozy%20campus%20dormitory%20room%20with%20bunk%20beds%2C%20a%20laundry%20line%20with%20colorful%20socks%2C%20plush%20toys%20and%20warm%20string%20lights%2C%20a%20cute%20cat%20peeking%20around%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20clean%20warm%20background&width=800&height=600&seq=cat-dorm-01&orientation=landscape",
  },
  {
    key: "food",
    label: "干饭日记",
    emoji: "🍜",
    desc: "食堂阿姨的手和外卖小哥的腿",
    count: "980+",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20cheerful%20university%20canteen%20scene%20with%20food%20trays%20of%20steaming%20noodles%20and%20rice%20dishes%2C%20happy%20students%20lining%20up%20chatting%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20clean%20warm%20background&width=800&height=600&seq=cat-food-02&orientation=landscape",
  },
  {
    key: "club",
    label: "社团现场",
    emoji: "🎤",
    desc: "迎新晚会的灯光和台下的欢呼",
    count: "760+",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20campus%20stage%20night%20with%20a%20student%20holding%20a%20microphone%2C%20spotlights%20and%20confetti%2C%20celebrating%20crowd%20below%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20clean%20warm%20background&width=800&height=600&seq=cat-club-03&orientation=landscape",
  },
  {
    key: "exam",
    label: "期末求生",
    emoji: "📚",
    desc: "图书馆、咖啡和最后的倔强",
    count: "1.5k+",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20cozy%20study%20scene%20with%20open%20books%20a%20laptop%20and%20a%20coffee%20cup%20on%20a%20wooden%20desk%2C%20library%20shelves%20in%20warm%20lamp%20light%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20clean%20warm%20background&width=800&height=600&seq=cat-exam-04&orientation=landscape",
  },
  {
    key: "fun",
    label: "奇闻趣事",
    emoji: "✨",
    desc: "校园里的猫与那些离谱日常",
    count: "680+",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20playful%20orange%20cat%20walking%20across%20a%20sunny%20campus%20running%20track%20with%20small%20leaves%20and%20shooting%20stars%2C%20playful%20and%20quirky%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20clean%20warm%20background&width=800&height=600&seq=cat-fun-05&orientation=landscape",
  },
  {
    key: "daily",
    label: "治愈日常",
    emoji: "🌤",
    desc: "被陌生人悄悄温暖的一刻",
    count: "1.1k+",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20sunny%20campus%20path%20with%20a%20student%20holding%20an%20umbrella%20and%20carrying%20books%2C%20autumn%20leaves%20floating%2C%20cozy%20and%20heartwarming%20mood%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20clean%20warm%20background&width=800&height=600&seq=cat-daily-06&orientation=landscape",
  },
];

export interface Post {
  id: number;
  cat: string;
  title: string;
  excerpt: string;
  tags: string[];
  emoji: string;
  like: number;
  view: string;
  author: string;
  time: string;
}

export const trendingPosts: Post[] = [
  {
    id: 1,
    cat: "治愈日常",
    title: "在电梯里，陌生同学帮我按住了楼层",
    excerpt:
      "加完班抱着一大箱书腾不出手，电梯里一个完全不认识的同学直接帮我按了楼层。虽然没来得及说谢谢，但今晚的疲惫都被治愈了。",
    tags: ["暖心", "电梯"],
    emoji: "🌤",
    like: 1286,
    view: "3.2万",
    author: "一只想被夸的考拉",
    time: "2小时前",
  },
  {
    id: 2,
    cat: "干饭日记",
    title: "食堂阿姨的“手抖”在我这儿失灵了",
    excerpt:
      "每次打红烧肉，阿姨手抖得像帕金森。今天轮到我的时候，她居然多加了一勺，还笑着说“多吃点长身体”。我感动得当场想写感谢信。",
    tags: ["食堂", "红烧肉", "快乐"],
    emoji: "🍜",
    like: 986,
    view: "2.1万",
    author: "红烧肉观察员",
    time: "5小时前",
  },
  {
    id: 3,
    cat: "期末求生",
    title: "期末周占座大战：我发现了隐藏自习室",
    excerpt:
      "图书馆六点就排起长队，正当我想放弃时，意外发现教学楼五楼拐角有个常年没人的自习室，暖气足、有插座、还安静。这波属于期末天选之子。",
    tags: ["图书馆", "期末", "自习"],
    emoji: "📚",
    like: 1543,
    view: "4.5万",
    author: "考试周幸存者",
    time: "昨天",
  },
  {
    id: 4,
    cat: "奇闻趣事",
    title: "被操场那只社牛橘猫“陪跑”了三圈",
    excerpt:
      "傍晚在操场跑步，一只橘猫突然钻出来，跟在我旁边匀速小跑。三圈之后它趴下，仿佛在说“体能训练到此结束”。猫比我自律，泪目。",
    tags: ["猫咪", "操场", "可爱"],
    emoji: "✨",
    like: 2031,
    view: "6.8万",
    author: "被猫带跑的菜鸟",
    time: "昨天",
  },
  {
    id: 5,
    cat: "社团现场",
    title: "迎新夜主持人口误：欢迎各“系”位同学",
    excerpt:
      "迎新晚会主持人激动过头，把“欢迎各位同学”念成了“欢迎各系位同学”，台下安静两秒后全场笑疯。当晚气氛直接拉满。",
    tags: ["社团", "迎新", "名场面"],
    emoji: "🎤",
    like: 867,
    view: "1.9万",
    author: "幕后灯光师",
    time: "1天前",
  },
  {
    id: 6,
    cat: "宿舍名场面",
    title: "舍友偷偷养了缸鱼，还给每只取了名字",
    excerpt:
      "周末回宿舍发现阳台多了个鱼缸，三条小鱼分别叫“数学”“毛概”“线代”，舍友说养它们是为了把挂科的风险养在阳台。我属实服气。",
    tags: ["宿舍", "养鱼", "离谱"],
    emoji: "🛏",
    like: 1102,
    view: "2.6万",
    author: "被笑死的上铺",
    time: "1天前",
  },
  {
    id: 7,
    cat: "治愈日常",
    title: "下雨天没带伞，被一个学妹拼了伞",
    excerpt:
      "晚自习结束突然下大雨，正站在门口发呆，一个不认识的学妹跑过来问我“要不一起”。她把我送到宿舍楼下，自己绕了一圈回去。",
    tags: ["雨天", "学妹", "感动"],
    emoji: "🌤",
    like: 1789,
    view: "5.4万",
    author: "被收留的学姐",
    time: "2天前",
  },
  {
    id: 8,
    cat: "干饭日记",
    title: "外卖小哥把汤撒了，第二天补了一份新的",
    excerpt:
      "点的麻辣烫汤撒了，我拍了照留言提醒。第二天小哥直接送了一份全新的过来，说“前天没送好，今天补上”。就冲这份担当，我单方面给他五星。",
    tags: ["外卖", "温暖"],
    emoji: "🍜",
    like: 941,
    view: "2.0万",
    author: "干饭不挂科",
    time: "2天前",
  },
  {
    id: 9,
    cat: "期末求生",
    title: "凌晨一点的图书馆，原来不只有我一个人",
    excerpt:
      "赶论文到凌晨，抬头发现整层楼还有十几个人在亮灯。那一瞬间突然不孤独了——大家都在为同一个目标努力，这种并肩作战真好。",
    tags: ["论文", "图书馆", "加油"],
    emoji: "📚",
    like: 2211,
    view: "7.3万",
    author: "凌晨赶稿人",
    time: "3天前",
  },
  {
    id: 10,
    cat: "宿舍名场面",
    title: "深夜茶话会聊到两点，聊的不是八卦是人生",
    excerpt:
      "关灯之后卧谈会开启，从明天吃什么聊到毕业去哪，从失恋聊到梦想。原来比白天更敞亮的，是夜里那几个愿意听你说话的人。",
    tags: ["卧谈会", "宿舍", "青春"],
    emoji: "🛏",
    like: 1345,
    view: "3.8万",
    author: "夜猫子宿舍长",
    time: "3天前",
  },
];

export interface Editorial {
  id: number;
  tag: string;
  title: string;
  lead: string;
  author: string;
  readTime: string;
  image: string;
}

export const editorials: Editorial[] = [
  {
    id: 1,
    tag: "期末企划",
    title: "期末周生存实录：图书馆、夜宵与那一点坚持",
    lead: "每到期末，图书馆的每一张桌子都像被预订过一样。我们从占座、泡图书馆到深夜的一碗热汤面里，拼出了属于大学生的共同记忆。这份实录，写给每一个在期末里咬牙前行的你。",
    author: "编辑部 · 小瓜",
    readTime: "5分钟",
    image:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20flat%20illustration%20of%20a%20wide%20campus%20library%20at%20night%20with%20many%20students%20studying%20under%20warm%20golden%20lamp%20glow%2C%20tall%20book%20shelves%20and%20large%20reading%20tables%2C%20cozy%20determined%20exam%20season%20mood%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20background&width=1200&height=675&seq=feat-editorial-01&orientation=landscape",
  },
  {
    id: 2,
    tag: "校园观察",
    title: "食堂排队背后的“时间经济学”",
    lead: "明明一食堂和二食堂只隔一百米，为什么大家愿意为二食堂的糖醋排骨排二十分钟？我们从菜色、窗口阿姨手速到下课时间，试着拆解食堂排队背后那套心照不宣的校园法则。",
    author: "编辑部 · 老饼",
    readTime: "6分钟",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20a%20busy%20but%20cheerful%20university%20canteen%20with%20a%20long%20winding%20queue%20of%20students%20and%20glowing%20food%20counters%2C%20isometric%20top%20down%20playful%20composition%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20background&width=1200&height=675&seq=feat-editorial-02&orientation=landscape",
  },
  {
    id: 3,
    tag: "编辑部来信",
    title: "致每一个匿名树洞：善良地讲，安静地听",
    lead: "我们做这个投稿箱的初衷，是希望每个想说又不想露脸的声音都有地方安放。吃瓜可以热闹，但别让热闹变成伤害。这篇文章，想和你聊聊「安全吃瓜」的几条底线。",
    author: "编辑部 · 全体",
    readTime: "4分钟",
    image:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20vector%20illustration%20of%20an%20open%20journal%20and%20pen%20on%20a%20warm%20wooden%20desk%20with%20little%20heart%20and%20speech%20bubble%20doodles%2C%20a%20sealed%20letter%20envelope%2C%20gentle%20and%20thoughtful%20mood%2C%20coral%20red%20gold%20and%20cream%20palette%2C%20soft%20background&width=1200&height=675&seq=feat-editorial-03&orientation=landscape",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "投稿会暴露我的真实身份吗？",
    a: "不会。我们默认以匿名方式处理投稿，投稿时不需要填写任何真实姓名、学号或联系方式。昵称是选填的，你也可以完全不写。我们只收集能帮助你表达的内容字段。",
  },
  {
    q: "投稿后多久能被看到？",
    a: "投稿会先进入小编的审核队列。审核通过的优质内容通常会在 24 小时内被整理并精选上榜。为了控制信息质量，未经审核的内容不会直接公开展示。",
  },
  {
    q: "什么样的内容不能投？",
    a: "为了保护大家，涉及真实个人隐私信息（姓名、学号、照片等）、人身攻击、造谣诽谤、违法违规或明显引战的内容不会通过审核。我们鼓励分享趣事与感受，不鼓励伤害他人。",
  },
  {
    q: "我的投稿为什么没有被采用？",
    a: "没有通过一般是因为内容涉及可识别的个人隐私、可能造成误解，或与平台基调不符。你可以调整表述后重新提交，去掉可识别信息，会更容易被收录。",
  },
  {
    q: "如果文章里提到我，可以删除吗？",
    a: "可以。任何内容在审核阶段都会被要求去除可识别信息，从源头上避免“点名”。如果你发现某条内容让你不适，可以通过底部联系方式告诉我们，我们会尽快处理。",
  },
  {
    q: "匿名分享和“吃瓜”的边界在哪里？",
    a: "一句话：聊事不聊人，讲感受不讲隐私。我们希望这里的“瓜”是校园生活里的趣事、共鸣和温暖，而不是把任何人架在火上烤。友善表达，是这里唯一的通行证。",
  },
];

export interface Testimonial {
  quote: string;
  name: string;
  role: string;
}

export const testimonials: Testimonial[] = [
  {
    quote: "在这里第一次敢把社死日常讲出来，评论区的同学都超级温柔，原来我并不孤单。",
    name: "匿名 · 大二",
    role: "常驻投稿人",
  },
  {
    quote: "期末那篇凌晨图书馆的稿子，看得我鼻子一酸。这个地方很懂大学生的那些小心思。",
    name: "匿名 · 研一",
    role: "忠实读者",
  },
  {
    quote: "编辑守则写得很清楚，只聊事不聊人。在这样的地方分享，才有安全感。",
    name: "匿名 · 大四",
    role: "投稿箱常客",
  },
];

export const rules: { emoji: string; title: string; desc: string }[] = [
  {
    emoji: "🙈",
    title: "不点名，只讲事",
    desc: "投稿与整理内容都会去掉可识别的姓名、学号与个人信息，避免任何“对号入座”的伤害。",
  },
  {
    emoji: "🚫",
    title: "不造谣，不引战",
    desc: "未经证实的内容请标注为猜测，我们不欢迎任何挑事、传谣与人身攻击的表述。",
  },
  {
    emoji: "💛",
    title: "友善吃瓜",
    desc: "把这里的“瓜”理解为校园生活里的趣事与共鸣，而不是把谁架在火上烤。",
  },
  {
    emoji: "🔒",
    title: "隐私优先",
    desc: "我们只收集表达所需的字段，你的身份在你按下提交那一刻就被保护起来了。",
  },
];